import { useState } from "react";
import { Reveal, Divider, Overline } from "@/components/layout/Atoms";
import { X } from "lucide-react";
import { useContent } from "@/contexts/ContentContext";
import { resolveMediaUrl } from "@/lib/api";

export default function Galerie() {
    const [active, setActive] = useState(null);
    const c = useContent();
    const g = c.galerie;

    return (
        <div data-testid="page-galerie" className="container-k pt-10 pb-20">
            <div className="max-w-3xl">
                <Overline>{g.hero.overline}</Overline>
                <h1 className="mt-4 font-heading font-light text-5xl md:text-7xl leading-[1.0] text-kayama-ink">
                    {g.hero.h1_part1} <span className="italic text-kayama-pink">{g.hero.h1_italic}</span>{g.hero.h1_part2}
                </h1>
                <p className="mt-6 text-kayama-brown-2 text-lg max-w-2xl">{g.hero.subtitle}</p>
            </div>

            <Divider />

            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6 auto-rows-[140px] md:auto-rows-[200px]">
                {g.images.map((img, i) => (
                    <Reveal
                        key={i}
                        delay={i * 80}
                        className={`relative overflow-hidden group cursor-pointer ${img.h === "tall" ? "row-span-2" : "row-span-1"}`}
                    >
                        <button onClick={() => setActive(img)} data-testid={`gallery-item-${i}`} className="block w-full h-full">
                            <img src={resolveMediaUrl(img.url)} alt={img.alt} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                            <div className="absolute inset-0 bg-kayama-brown/0 group-hover:bg-kayama-brown/30 transition-colors duration-500" />
                            <div className="absolute bottom-3 left-3 right-3 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                                <p className="text-white text-xs uppercase tracking-[0.2em]">{img.alt}</p>
                            </div>
                        </button>
                    </Reveal>
                ))}
            </div>

            {active && (
                <div className="fixed inset-0 z-[60] bg-kayama-brown/90 backdrop-blur-sm flex items-center justify-center p-6" onClick={() => setActive(null)} data-testid="gallery-lightbox">
                    <button onClick={() => setActive(null)} data-testid="lightbox-close" className="absolute top-6 right-6 text-white hover:text-kayama-gold">
                        <X size={32} />
                    </button>
                    <img src={resolveMediaUrl(active.url)} alt={active.alt} className="max-w-full max-h-full object-contain" />
                </div>
            )}
        </div>
    );
}
